import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListCreationScreen from '../enums/ListCreationScreen';

type logCreateNewListClickedParams = {
  list_creation_screen: ListCreationScreen;
};

/**
 * A user clicks the 'create new list button' at the bottom of the list selection screen. Note: this is not the bookmark icon to add a new saved item, but rather the CTA to create a new list.
 * @param params - Attributes to log with the amplitude event
 * @param params.list_creation_screen - The screen where list creation was completed— this is used to differentiate saved funnels.
 */
const logCreateNewListClicked = ({ list_creation_screen }: logCreateNewListClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('create new list clicked', { 'list creation screen': list_creation_screen }, callback);
};

export default logCreateNewListClicked;
